/**
 * List of HTML tag names that are whitespace sensitive.
 */
export const whitespaceSensitiveTagNames = [
  'pre',
  'script',
  'style',
  'textarea'
]
